import { render, staticRenderFns } from "./DocumentDigitalRepresentationModal.vue?vue&type=template&id=9ae11a1a"
import script from "./DocumentDigitalRepresentationModal.vue?vue&type=script&lang=ts"
export * from "./DocumentDigitalRepresentationModal.vue?vue&type=script&lang=ts"
import style0 from "./DocumentDigitalRepresentationModal.vue?vue&type=style&index=0&id=9ae11a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports